/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ISaverAvatars,
  ISaverAvatarsInterface,
} from "../../../contracts/tokens/ISaverAvatars";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "attribute",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    name: "AttributeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_toTokenId",
        type: "uint256",
      },
    ],
    name: "BatchMetadataUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "MetadataUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TOTAL_NFTs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "safeMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "safeMintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "setContractDescription",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_externalUrl",
        type: "string",
      },
    ],
    name: "setContractExternalUrl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_imageUrl",
        type: "string",
      },
    ],
    name: "setContractImageUrl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "background",
                type: "string",
              },
              {
                internalType: "string",
                name: "letter",
                type: "string",
              },
              {
                internalType: "string",
                name: "body",
                type: "string",
              },
              {
                internalType: "string",
                name: "skin",
                type: "string",
              },
              {
                internalType: "string",
                name: "eyes",
                type: "string",
              },
              {
                internalType: "string",
                name: "emotion",
                type: "string",
              },
              {
                internalType: "string",
                name: "horns",
                type: "string",
              },
              {
                internalType: "string",
                name: "clothes",
                type: "string",
              },
              {
                internalType: "string",
                name: "accessory",
                type: "string",
              },
            ],
            internalType: "struct ISaverAvatars.LayerAttributes",
            name: "layerAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "psychotype",
                type: "string",
              },
              {
                internalType: "string",
                name: "genotype",
                type: "string",
              },
              {
                internalType: "string",
                name: "hobby",
                type: "string",
              },
              {
                internalType: "string",
                name: "vitality",
                type: "string",
              },
              {
                internalType: "string",
                name: "diligence",
                type: "string",
              },
              {
                internalType: "string",
                name: "intelligence",
                type: "string",
              },
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "telegram",
                type: "string",
              },
            ],
            internalType: "struct ISaverAvatars.OtherAttributes",
            name: "otherAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "value",
                type: "string",
              },
              {
                internalType: "string",
                name: "timestamp",
                type: "string",
              },
            ],
            internalType: "struct ISaverAvatars.Birthday",
            name: "birthday",
            type: "tuple",
          },
        ],
        internalType: "struct ISaverAvatars.Attributes[]",
        name: "_attributes",
        type: "tuple[]",
      },
    ],
    name: "setTokenAttributes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "setTokenDescription",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_externalUrl",
        type: "string",
      },
    ],
    name: "setTokenExternalUrl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_imageBaseUrl",
        type: "string",
      },
    ],
    name: "setTokenImageBaseUrl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    name: "setTokenName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_telegram",
        type: "string",
      },
    ],
    name: "setTokenTelegram",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenAttributes",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "background",
            type: "string",
          },
          {
            internalType: "string",
            name: "letter",
            type: "string",
          },
          {
            internalType: "string",
            name: "body",
            type: "string",
          },
          {
            internalType: "string",
            name: "skin",
            type: "string",
          },
          {
            internalType: "string",
            name: "eyes",
            type: "string",
          },
          {
            internalType: "string",
            name: "emotion",
            type: "string",
          },
          {
            internalType: "string",
            name: "horns",
            type: "string",
          },
          {
            internalType: "string",
            name: "clothes",
            type: "string",
          },
          {
            internalType: "string",
            name: "accessory",
            type: "string",
          },
        ],
        internalType: "struct ISaverAvatars.LayerAttributes",
        name: "layerAttributes",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "psychotype",
            type: "string",
          },
          {
            internalType: "string",
            name: "genotype",
            type: "string",
          },
          {
            internalType: "string",
            name: "hobby",
            type: "string",
          },
          {
            internalType: "string",
            name: "vitality",
            type: "string",
          },
          {
            internalType: "string",
            name: "diligence",
            type: "string",
          },
          {
            internalType: "string",
            name: "intelligence",
            type: "string",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "telegram",
            type: "string",
          },
        ],
        internalType: "struct ISaverAvatars.OtherAttributes",
        name: "otherAttributes",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "value",
            type: "string",
          },
          {
            internalType: "string",
            name: "timestamp",
            type: "string",
          },
        ],
        internalType: "struct ISaverAvatars.Birthday",
        name: "birthday",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ISaverAvatarsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ISaverAvatarsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ISaverAvatars__factory extends ContractFactory {
  constructor(...args: ISaverAvatarsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<ISaverAvatars> {
    return super.deploy(overrides || {}) as Promise<ISaverAvatars>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ISaverAvatars {
    return super.attach(address) as ISaverAvatars;
  }
  override connect(signer: Signer): ISaverAvatars__factory {
    return super.connect(signer) as ISaverAvatars__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ISaverAvatarsInterface {
    return new utils.Interface(_abi) as ISaverAvatarsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISaverAvatars {
    return new Contract(address, _abi, signerOrProvider) as ISaverAvatars;
  }
}
